<template>
  <div class="fill-height">
    <GmapMap
      :center="currentLocation ? { lat:position.lat, lng:position.lng } : markers[0].position"
      :zoom="zoom"
      :options="options"
      map-type-id="terrain"
      class="map"
      ref="map"
    >
      <GmapMarker
        v-for="(marker, index) in markers"
        :key="'map-marker--' + index"
        :position="marker.position ? marker.position : position"
        :title="marker.title"
        :icon="marker.icon ? marker.icon : ''"
      />
      <GmapCircle
        v-for="(geofence, index) in geofences"
        :key="'geofence--' + index"
        :center="geofence"
        :radius="geofence.radius"
        :options="geofenceOptions"
      />
    </GmapMap>
  </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';

import LocationUtil from '@/util/location-util';

import hasAppDialog from '@/mixins/hasAppDialog';
import inGeofence from '@/mixins/location/inGeofence';

export default {
  name: 'MapLoader',
  mixins: [hasAppDialog, inGeofence],

  props: {
    markers: {
      type: Array,
      required: true,
    },
    geofences: {
      type: Array,
      required: true,
    },
    currentLocation: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      position: {
        lat: -1,
        lng: -1,
      },
      zoom: 17,
      options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        disableDefaultUi: false,
      },
    };
  },

  computed: {
    geofenceOptions() {
      return {
        fillColor: this.$vuetify.theme.currentTheme.primary,
        strokeColor: this.$vuetify.theme.currentTheme.primary,
      };
    },
  },

  watch: {
    markers() {
      this.loadMap();
    },

    geofence() {
      this.loadMap();
    },
  },

  methods: {
    loadMap() {
      if (!isEmpty(this.markers)) {
        if (this.currentLocation) {
          this.loadCurrentLocation();
        } else {
          this.loadGMap();
        }
      }
    },

    loadCurrentLocation() {
      LocationUtil.retrievePosition(
        (locationData) => {
          this.position = {
            lat: locationData.latitude,
            lng: locationData.longitude,
            acc: locationData.accuracy,
          };

          this.$emit('update-accuracy', locationData.accuracy);
          this.loadGMap();
        },
        (error) => this.showAppErrorDialog({ message: `${this.$t('dialogs.error.mapFail.message')} ${error.message}` }),
      );
    },

    loadGMap() {
      this.$refs.map.$mapPromise.then(() => {
        if (!isEmpty(this.geofence.flatMap((geoFenceAssignment) => geoFenceAssignment.geofences))) {
          if (this.currentLocation) {
            this.$emit(
              'update-geofence-result',
              this.getLocationGeofenceResult(this.position),
            );
          }
        }
      });
    },
  },

  mounted() {
    window.vueGoogleMapsInit();
    this.loadMap();
  },
};

</script>

<style scoped>
.map {
  height: 100%;
  width: 100%;
}
</style>
